import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IServicePackage } from '@clickersphere/core/entities/IServicePackage';
import ServicePackageService from '@clickersphere/core/services/ServicePackageService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const SERVICE_PACKAGES_QUERY_KEY = 'service-packages';

export type ServicePackageQueryData = WithQueryStatus<IServicePackage>;

export function useServicePackages() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: servicePackages,
    isSuccess: isServicePackagesSuccess,
    isFetching: isServicePackagesFetching,
    isLoading: isServicePackagesLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(SERVICE_PACKAGES_QUERY_KEY),
    queryFn: async () => {
      const data = await ServicePackageService.getAll();
      return data as ServicePackageQueryData[];
    },
    select: (data) => data.sort((a, b) => (a.name > b.name ? 1 : -1)),
  });

  return {
    servicePackages,
    isServicePackagesSuccess,
    isServicePackagesFetching,
    isServicePackagesLoading,
  };
}
